import CheckIcon from "../../../../../../../assets/svg/check-icon";
import { getHelpdeskLabels } from "../../../../../../../utils/constants/mappings";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../../../redux/store";

interface RequestSupportSelectorProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const RequestSupportSelector = ({
  checked,
  onChange,
}: RequestSupportSelectorProps) => {
  const region = useSelector(
    (state: RootState) => state?.auth?.client?.region
  );
  const helpdeskLabels = getHelpdeskLabels(region ?? "UK");
  return (
    <div className="flex flex-col gap-1">
      <button
        type="button"
        onClick={() => onChange(!checked)}
        className={`flex items-center gap-2 w-full p-3 rounded-[8px] border border-selected-option-highlight dark:border-selected-option-highlight cursor-pointer text-left ${
          checked
            ? "bg-crm-card-highlight-2 dark:bg-crm-card-highlight-2-dk"
            : ""
        }`}
      >
        <div
          className={`shrink-0 w-[18px] h-[18px] rounded-[4px] border flex items-center justify-center ${
            checked
              ? "bg-verba-blue dark:bg-verba-blue-dk border-verba-blue dark:border-verba-blue-dk"
              : "bg-popper-bg dark:bg-popper-bg-dk border-gray-placeholder dark:border-gray-placeholder-dk"
          }`}
        >
          {checked && (
            <CheckIcon className="w-3 h-3 text-fixed-white dark:text-fixed-white-dk" />
          )}
        </div>
        <div className="flex flex-col">
          <span className="text-md font-medium text-heading-text dark:text-heading-text-dk leading-normal">
            Request Support
          </span>
          <span className="text-xs font-normal text-data dark:text-data-dk leading-normal">
            Schedule a call or a meeting with our support team to discuss this {helpdeskLabels.ticketSingularLower}
          </span>
        </div>
      </button>
    </div>
  );
};

export default RequestSupportSelector;
